<template>
  <ExpandTransition>
    <div v-if="needConfirm" class="fixed inset-0 flex items-center justify-center px-4">
      <div class="max-w-xl w-full">
        <h2 class="self-center text-center uppercase md:px-7 text-2xl md:text-4xl">Подтверждение номера телефона</h2>

        <p class="mt-6 text-center mb-5 px-5 text-sm md:text-base tracking-wide">
          На указанный Вами номер телефона: {{ confirmPhone }} было отправлено СМС с кодом подтверждения
        </p>

        <Input v-model="smsCode" :error="errors.sms_code" placeholder="Код из СМС" autocomplete="off" class="mt-3" />

        <a
          v-if="!smsTimeRemaining"
          tabindex="0"
          class="cursor-pointer text-white hover:text-gray-500 border-b-2 border-dotted hover:border-gray-500"
          @click="sendNewSms"
        >
          Запросить новое СМС
        </a>

        <p v-else>Отправить СМС повторно через: {{ smsTimeRemainingFormated }}</p>

        <div class="flex justify-center mt-6">
          <Button :disabled="smsCode && smsCode.length != 6" @click="clickConfirm"> Подтвердить </Button>
        </div>
      </div>
    </div>
  </ExpandTransition>
</template>

<script setup>
import Input from '@/components/Input.vue'
import Button from '@/components/Button/Button.vue'
import ExpandTransition from '@/components/ExpandTransition.vue'

import {
  needConfirm,
  confirmPhone,
  smsCode,
  smsTimeRemaining,
  smsTimeRemainingFormated,
  sendNewSms,
  clickConfirm,
} from '@/store/smsAccept'

import { ref } from 'vue'

const errors = ref({})
</script>
